import { render, staticRenderFns } from "./ProfileTab.vue?vue&type=template&id=7be2f7be&scoped=true&"
import script from "./ProfileTab.vue?vue&type=script&lang=js&"
export * from "./ProfileTab.vue?vue&type=script&lang=js&"
import style0 from "./ProfileTab.vue?vue&type=style&index=0&id=7be2f7be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be2f7be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/projects/tus-cc-auth/tus-cc-auth/frontend/tusauth/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VLayout,VProgressCircular})
